import { useSearchParams } from "react-router-dom";
import KakaoOAuthCallback from "./KakaoOAuthCallback";
import { PATH } from "routes/paths";

// 제휴(레퍼럴) 전용 카카오 콜백 — /referral/oauth/kakao
// 이 경로로 돌아왔다는 사실 자체가 제휴 퍼널을 의미하고,
// state 에는 레퍼럴 코드만 실려 있다.
const KakaoLoginRedirectReferral = () => {
  const [searchParams] = useSearchParams();
  const referralCode = searchParams.get("state") ?? undefined;

  return (
    <KakaoOAuthCallback
      callbackPath={PATH.kakaoLoginRedirectReferral}
      referralCode={referralCode}
      fallbackPath={`${PATH.referralLogin}?code=${encodeURIComponent(
        referralCode ?? ""
      )}`}
    />
  );
};

export default KakaoLoginRedirectReferral;
